import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function Connexion() {
  const [pseudo, setPseudo] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const baseUrl = process.env.REACT_APP_API_USER_URL;
    const response = await fetch(`${baseUrl}/api/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ pseudo, password: motDePasse }) // attention ici, le champ backend est `password`
    });

    if (response.ok) {
      const userData = await response.json();
      login(userData);
      navigate("/murs");
    } else {
      alert("Identifiants incorrects");
    }
  };

  return (
    <div className="form-container retro-form">
      <h2>Connexion</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Pseudo"
          value={pseudo}
          onChange={(e) => setPseudo(e.target.value)}
        />
        <input
          type="password"
          placeholder="Mot de passe"
          value={motDePasse}
          onChange={(e) => setMotDePasse(e.target.value)}
        />
        <button type="submit" className="retro-btn">Se connecter</button>
      </form>
      <Link to="/mot-de-passe-oublie">Mot de passe oublié ?</Link>
    </div>
  );
}

export default Connexion;